export const toOptionList = (
  items = [],
  { valueKey = "id", labelFn, fallbackLabelKeys = ["name", "description", "label", "code"] } = {}
) =>
  (items || [])
    .filter(Boolean)
    .map((item) => {
      const rawValue = item?.[valueKey] ?? item?.id;
      if (rawValue === undefined || rawValue === null) return null;
      let label = labelFn ? labelFn(item) : undefined;
      if (!label) {
        for (const key of fallbackLabelKeys) {
          if (item?.[key]) {
            label = item[key];
            break;
          }
        }
      }
      const normalizedLabel = label?.toString().trim();
      if (!normalizedLabel) return null;
      return {
        id: String(rawValue),
        name: normalizedLabel,
      };
    })
    .filter(Boolean);
